module.exports = "/assets/data/6bf2042b7b3151761293d3810a564cf6-EC2Y.data.json";